import app from 'flarum/forum/app';
export default function userById(id) {
  return app.store.getById('users', String(id)) ?? null;
}
flarum.reg.add('forumaker-arena', 'common/helpers/userById', userById);